
import regTop from '../../../components/Reception/reg/regTop.vue'
import regBottom from '../../../components/Reception/reg/regBottom.vue'
import { post, fetch, Del, put } from "../../../ask/axios";

import validationPT from '../../../components/Reception/reg/validationPT.vue'
import { watch } from 'fs';
import {getQueryVariable} from '@/util/util'
export default {
  metaInfo: {
    // title: '客户注册_百运网', // set a title
    // meta: [{                 // set meta
    //   name: 'keyWords',
    //   content: '会员注册，国际物流平台'
    // }],
    link: [{                 // set link
      rel: 'asstes',
      href: 'https://www.by56.com/reg/registerCst'
    }]
  },
  name: "registerCst",
  //组件引用
  components: {regTop,regBottom,validationPT},

  data(){
    return{
        api: {
          url: "",
          param: "",
          response: {},
          message: ""
        },
        //手机号码
        phoneInfo:{
          PhoneNumber:'',//手机号
          PhoneNumMsg:'',
          isShowBlueIcon1:false,
        },
        //邀请码
        inviteInfo:{
          invitationCd:'',
          invitationCdMsg:'',
          isShowBlueIcon1:false,
        },
        //密码
        passwInfos:{
          Password:'',//密码
          Password2:'',//确认密码
          PassMsg:'',
          PassMsg2:'',
          isShowBlueIcon:false,
          blueIconSue:false,
        },
 
        //手机验证码
        isShowVef:true, //显示拼图验证按钮还是手机验证码输入框
        vefInfos:{
          PhoneVefCode:'',
          WaitTime:'', //等待时间
          PhoneCodeMsg:'',
          // isShowBlueIcon:true,
          isShowBlueIcon:false,
        },

        VefInfosBk:{}, //手机号码没有更改，120s之后不用重复验证拼图，直接获取之前的验证，所以保存之前的验证信息
        
        //从哪里知道百运
        By56Infos:{
          promoteValue:'',
          regPromote:[],
          selcttMsg:'',
          SalesManPhoneNum:'',//业务员手机号码
          SalesManMsg:'',

         //业务员是否显示
         isShowSaleMan:false,
         blueIconSue:false,
          
        },
       
        ckdService:true, //是否同意服务协议
        Agreement:false,//服务协议

        Isregister:false, //注册按钮显示蓝色和灰色
        inviteEnterCode:''
        
    }
  },

  created(){ //创建后
    this.KnowBy56();//从哪里知道百运

    // sensors.track('BuyProduct', {
    //   ProductName: "MacBook Pro", 
    //   ProductPrice: 123.45, 
    //   IsAddedToFav: false,
    // });

    //获取邀请进来的   邀请码
    // this.inviteEnterCode = getQueryVariable('InvitaCode')
   
  },
 mounted(){
  this.inviteEnterCode = this.$route.query.InvitaCode
    
  if(this.inviteEnterCode){
    this.inviteInfo.invitationCd=this.inviteEnterCode
  }
  
  // v-if="!inviteEnterCode"
 },
  watch:{
    'phoneInfo.PhoneNumber'(newValue,oldValue) {
      if(this.phoneInfo.isShowBlueIcon1 && newValue!=oldValue){
          this.isShowVef=true
      }
   }
  },
  methods:{
    //点击生成拼图验证
    clkVefBtn(){
      console.log(5555);
      if(this.phoneInfo.PhoneNumber && this.phoneInfo.isShowBlueIcon1){
        this.$refs.vefCode.GetSlideBlockApi(); //调用图片接口，获取验证图片
        this.existence(1,this.phoneInfo.PhoneNumber,null);
      }else{
       // this.phoneInfo.PhoneNumMsg="手机号码格式不正确"
        
      }
        
    },
    //拼图验证是否成功
    getVefCodeTrue(msg){

      this.VefInfosBk=msg

      if(msg.Res==true){
        this.isShowVef=false
        this.vefInfos.PhoneVefCode=''
        if(this.phoneInfo.PhoneNumber && this.phoneInfo.isShowBlueIcon1){
          this.PhoneValiCodeApi(msg.MarkCode,msg.LstMouseTrack)
        }else{
          this.phoneInfo.PhoneNumMsg="手机号码格式不正确"
        }
       
      }else{
        this.isShowVef=true
      }
      //console.log('msg  == ' + msg);
    },
    //点击获取手机验证码
    clkGetPhoneCode(){
      this.PhoneValiCodeApi(this.VefInfosBk.MarkCode,this.VefInfosBk.LstMouseTrack)   
    },

    //获取手机验证码接口
    PhoneValiCodeApi(code,track){  
      let that = this;
      let trackArr=[]
      trackArr=track
      that.api.param={
        markCode:code,
        lstMouseTrack:trackArr,
        mobile:that.phoneInfo.PhoneNumber
      },
      // that.api.url=this.$api02+"/api/EbayCustomer/MobileCode/SendMobileVerifyCodeFrontRegist";
      that.api.url=this.$api04 + "Basics/api/MobileCode/SendMobileVerifyCodeFrontRegist";
      post(that.api.url,that.api.param).then(function (res) {
        let Message=''
        if(!res.Results){
          Message=res.Message
        }
        //定制埋点--手机验证码是否成功
        sensors.track('get_code_result', {
          service_type:'注册',
          get_type:'手机号',
          is_success:res.Results, 
          fail_reason:Message,
          return_duration:'',
        });


          that.vefInfos.PhoneCodeMsg=res.Message;
          if(res.IsOK && res.Results){
          that.timerna();
        }
      })
    },
     //验证码倒计时
     timerna(){
      const totalTime = 120;
      let timer=null
      if (!timer) {
        this.vefInfos.WaitTime = totalTime;
        timer = setInterval(() => {
        if (this.vefInfos.WaitTime > 0 && this.vefInfos.WaitTime <= totalTime) {
          this.vefInfos.WaitTime--;
         } else {
          clearInterval(timer);
          timer = null;
         }
        }, 1000)
       }
    },

    //外部链接进来，业务员手机号已经有了
    KnowBYselect(){
      if(this.$route.query.InvitaCode){
        return true;
      }else{
        return false;
      }
    },
    //从哪里知道百运
    KnowBy56(){
      let that = this;
      that.api.param={
        useInfo:0
      },
      // that.api.url=this.$api02+"/api/EbayCustomer/KnowBY/QueryKnowBYList";
      that.api.url=this.$api04 + "Basics/api/KnowBY/QueryKnowBYList";
      fetch(that.api.url,that.api.param).then(function (res) {
        if(res.IsOK&&res.Results!=null){
          that.By56Infos.regPromote=res.Results;
          if(that.$route.query.InvitaCode){
            that.By56Infos.isShowSaleMan=true;
            that.By56Infos.SalesManPhoneNum=that.$route.query.InvitaCode;
            that.By56Infos.regPromote.forEach(e =>{
              if(e.HandleType==2){
                that.By56Infos.promoteValue=e.Id;
              }
            })
          }
        }
      })
    },

    //-------验证填写的信息------------------//
    IsInvitationCd(){
      
      if(this.inviteInfo.invitationCd){
        // if('后端验证错误'){
          if(0){
           this.inviteInfo.PhoneNumMsg='邀请码错误'
          this.inviteInfo.isShowBlueIcon1=false
          return false;
        }
      }
    },
    IsPhoneNum(){  //验证电话号码      
      if(!this.phoneInfo.PhoneNumber){
        this.phoneInfo.PhoneNumMsg='请输入手机号码'
        this.phoneInfo.isShowBlueIcon1=false
        return false;
      }
      var reg=/^1[3456789]\d{9}$/;
      this.phoneInfo.PhoneNumber = this.phoneInfo.PhoneNumber.trim()
      if(!reg.test(this.phoneInfo.PhoneNumber)){ 
        this.phoneInfo.PhoneNumMsg='手机号码格式不正确'
        this.phoneInfo.isShowBlueIcon1=false
        return false;
      }else{
        this.phoneInfo.PhoneNumMsg=''
        this.phoneInfo.isShowBlueIcon1=true;
        return true;
      }
    },
     //是否存在验证
     existence(val,PhoneNumber,SaleMobile){
      let that = this;
      that.api.param={
      }
      if(val==1){
        that.api.param.Mobile=PhoneNumber
      }
      if(val==2){
        that.api.param.SaleMobile=SaleMobile
      }
      
      // that.api.url=this.$api02+"/api/EbayCustomer/CustomerRegist/RegistVerify";
      that.api.url=this.$api04+"Basics/api/CustomerRegist/RegistVerify";
      post(that.api.url,that.api.param).then(function (res) {
        if(res.Results==true){
          if(val==1){
            that.phoneInfo.isShowBlueIcon1=true;
            that.$refs.vefCode.clkOpenRef() //验证通过，打开拼图验证
          }else if(val==2){
            that.By56Infos.blueIconSue=true;
          }
          
         // that.$emit('phoneNum',PhoneNumber) 
          return true;
        }else{
          if(val==1){
            that.phoneInfo.isShowBlueIcon1=false
            that.phoneInfo.PhoneNumMsg='手机号码已经注册，请重新输入'
          }else if(val==2){
            that.By56Infos.blueIconSue=false
            that.By56Infos.SalesManMsg='业务员手机号码不存在，请重新输入'
          }
          return false;
        }
    })
    },
    //验证手机验证码是否正确
     blurVefCode(){
      let that = this;

      if(this.isShowVef&&!that.vefInfos.PhoneVefCode){
        that.vefInfos.PhoneCodeMsg='请获取填写验证码';
        return false;
      }

      if(!this.isShowVef&&!that.vefInfos.PhoneVefCode){
        
        that.vefInfos.PhoneCodeMsg='验证码不能为空';
        return false;
      }

      let sendDate=(new Date()).getTime();

      that.api.param={
        mobileValidateCode:that.vefInfos.PhoneVefCode,
        mobile:that.phoneInfo.PhoneNumber,
      };
      
      // that.api.url=this.$api02+"/api/EbayCustomer/MobileCode/GetVerifyCode";
      that.api.url=this.$api04 + "Basics/api/MobileCode/GetVerifyCode";
      fetch(that.api.url,that.api.param).then(function (res) {

        let receiveDate = (new Date()).getTime();
        let responseTimeMs = receiveDate - sendDate;
        
          //定制埋点-手机验证码是否正确
          sensors.track('verify_result', {
            is_success:res.Results, 
            fail_reason:res.Message,
            return_duration:responseTimeMs,
          });
       

        if(res.Results==true){
          that.vefInfos.isShowBlueIcon=true
          that.vefInfos.PhoneCodeMsg='';
          return true;
       }else{
          that.vefInfos.PhoneCodeMsg=res.Message;
          return false;
       }
      })
    },
    //验证密码
    IsPass(){
      var reg=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
      if(!reg.test(this.passwInfos.Password)){ 
        this.passwInfos.PassMsg='密码长度必须大于6位并且包含英文和数字'
        this.passwInfos.isShowBlueIcon=false
        return false;
      }else{
        this.passwInfos.isShowBlueIcon=true
        this.passwInfos.PassMsg=''
        return true;
      }
    },
    //判断第一次第二次密码是否一样
    IsPass2(){
      if((this.passwInfos.Password != this.passwInfos.Password2) || !this.passwInfos.Password2){ 
        this.passwInfos.PassMsg2='两次密码输入不一致'
        this.passwInfos.blueIconSue=false
        return false;
      }else{
        this.passwInfos.PassMsg2=''
        this.passwInfos.blueIconSue=true        
        return true;
      }
    },
    //从哪里知道百运选择
    StatusSelect(){
      if(!this.By56Infos.promoteValue){
        this.By56Infos.selcttMsg='请选择您从哪里知道百运'
      }else{
        this.By56Infos.selcttMsg=''
      }
    
      this.By56Infos.regPromote.forEach(e =>{
        if(e.Id==this.By56Infos.promoteValue){
          if(e.HandleType==2){
            this.By56Infos.isShowSaleMan=true;
          }else{
            this.By56Infos.isShowSaleMan=false;
            this.By56Infos.SalesManPhoneNum=null
          }
        }
      })
    },
    //验证业务员手机号码
    IsSalesmandoc(){
      
      if(this.By56Infos.SalesManPhoneNum){
        this.By56Infos.SalesManPhoneNum = this.By56Infos.SalesManPhoneNum.trim()
      }
      var reg=/^1\d{10}$/;
      if(!reg.test(this.By56Infos.SalesManPhoneNum)){ 
        this.By56Infos.SalesManMsg='业务员手机号码格式不正确'
        return false;
      }else{
        this.By56Infos.SalesManMsg=''
        this.existence(2,null,this.By56Infos.SalesManPhoneNum);
        return true;
      }
    },

    //立即注册按钮
    clkRegisterBtn(){
      //console.log('this.By56Infos.SalesManPhoneNum ' + this.By56Infos.SalesManPhoneNum);
      debugger

      this.IsPhoneNum()
      // this.blurVefCode()
      // this.IsPass()
      // this.IsPass2()
      this.StatusSelect()
      this.IsSalesmandoc()
      if(!this.phoneInfo.isShowBlueIcon1 || !this.vefInfos.isShowBlueIcon
       ){
          return false
        }
        // //是否选中的是业务员
        // let HandleType=null
        // this.By56Infos.regPromote.forEach(e =>{
        //   if(this.By56Infos.promoteValue == e.Id){
        //     HandleType=e.HandleType
        //     return false
        //   }
        // })
        // if(HandleType==2 && !this.By56Infos.blueIconSue){
        //   return false
        // }

        if(!this.ckdService){
          this.$confirm("请阅读并同意 《百运网服务条款》！", "提示", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
          }).catch(() => {});
          return false;
        }


        this.RegisterApi();
    },

    RegisterApi(){ //注册接口
      let that=this
      let ThirdValue = ''
      if(this.$route.query.ThirdValue) {
        ThirdValue = this.$route.query.ThirdValue
      }
      that.Isregister=true; //注册中
      
      that.api.param={
        Mobile:that.phoneInfo.PhoneNumber,
        Password:that.passwInfos.Password,
        KnowBY:that.By56Infos.promoteValue,
        // InvitaCode:that.By56Infos.SalesManPhoneNum,
        MobileCode:that.vefInfos.PhoneVefCode, //手机验证码
        ThirdValue:ThirdValue,//第三方注册来源
        SlideBlock:{},
        InvitaCode:that.inviteInfo.invitationCd
      }
      that.api.param.SlideBlock.MarkCode=this.VefInfosBk.MarkCode
      that.api.param.SlideBlock.LstMouseTrack=this.VefInfosBk.LstMouseTrack
      
      that.api.url=this.$api02+"/api/EbayCustomer/CustomerRegist/Regist";
      post(that.api.url,that.api.param).then(function (res) {
        // if( that.api.param.InvitaCode){
        //    that.registerResult('客户邀请',res.IsOK,res.Message)
        // }else{
        //   that.registerResult('客户注册',res.IsOK,res.Message)
        // }
       
        that.registerSyncApi(res)
        
        that.Isregister=false; //注册中
        //debugger
        if(res.IsOK){         
           //注册成功
           that.$router.push('/reg/registerSucf')
          //抽奖页面, 触发888
          // that.$emit('registerSuccess')
           // window.location.href ="/reg/registerSucf"
        }else if(!res.IsOK){
          that.$confirm(res.Message, "提示", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

            if(res.ErrorCode=='S0001'||res.ErrorCode=='S0002'||res.ErrorCode=='S0003'||res.ErrorCode=='S0004'||res.ErrorCode=='S0005'){
              that.isShowVef=true
              that.vefInfos.PhoneVefCode=''
            }

          }).catch(() => {});
         return false;
        }
      })
    },


    registerSyncApi(item){ //埋点传服务端接口
      let that=this
      let userId=""
      let Message=""
      if(item.IsOK){
        userId=item.Message
      }else{
        Message=item.Message
      }
      let anonymousId=sensors.quick('getAnonymousID')
      that.Isregister=true; //注册中
      that.api.param={
        registration:"注册客户",
        is_success:item.IsOK,
        fail_reason:Message,
        app_name:"电商Web端",
        platform_type:"web", //手机验证码
        is_login:false,//第三方注册来源
        UserId:userId,
        anonymousId:anonymousId,
      }

      that.api.url=this.$api02+"/api/EbayCustomer/CustomerRegist/RegisterSync";
      post(that.api.url,that.api.param).then(function (res) {
       
      })
    },

    //----------------下面的部分--------------------------//
    //打开服务协议
    AgreementOpen(){
      this.Agreement=true;
    },
    //关闭服务协议
    getClose(){
      this.Agreement=false; 
    },
    //同意协议服务
    Agreementend(){
      this.ckdService=true;
      this.Agreement=false;
    },
    //注册成为供应商
    Supplier(){
      window.location.href =this.$apiAll03+"Suppliers/Register_gy.aspx"
    },
  }

}





// WEBPACK FOOTER //
// ./src/common/js/reg/registerCst.js